import {register} from '@shopify/theme-sections'
import $ from 'jquery'
import 'slick-carousel'
import '../../styles/components/carousel.scss'
import '../../styles/sections/section-border-content.scss'

export default register(`section-border-content`, {

    onLoad() {
        $(`.border-content-wrapper`).slick({
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: `<button type="button" class="slick-prev link"></button>`,
        nextArrow: `<button type="button" class="slick-next link"></button>`,
        responsive: [
            {
                breakpoint: 768,
                settings: `unslick`
            }
        ]
      })
    },

    onUnload() {
        $(`.border-content-wrapper`).unslick()
    },
})
